<div class="sso-page">
  <!-- Header (desktop only) -->
  <header class="sso-header">
    <div class="navbar">
      <img src="/assets/images/futurenav-logo.png" alt="Future Nav – Compass logo" />
    </div>
  </header>

  <!-- Top Decorative Strip (mobile only) -->
  <div class="decorative-strip top-strip">
    <img
      src="/assets/images/biq/right-panel.svg"
      alt=""
      class="decorative-strip-img"
    />
  </div>

  <!-- Main Content Area -->
  <div class="main-content">
    <!-- Left Decorative Strip (using left-panel image) -->
    <div class="decorative-strip left-strip">
      <img
        src="/assets/images/biq/left-panel.png"
        alt=""
        class="decorative-strip-img"
      />
    </div>

    <!-- Left Panel with SVG -->
    <div class="left-panel">
      <img
        src="/assets/images/left-panel.png"
        alt="Turn your interests and skills into career possibilities"
        class="left-panel-svg"
      />
      <div class="left-panel-text">
        <div class="left-panel-div">
          <p>Turn your interests</p>
          <p> and skills into career</p>
          <p> possibilities.</p>
        </div>
  
      </div>
    </div>

    <!-- Right Panel with Sign In -->
    <div class="right-panel">
      <!-- FutureNav Logo (mobile only) -->
      <div class="futurenav-logo-container">
        <span class="futurenav-logo">
          <span class="logo-asterisk">*</span>future<span class="logo-highlight">nav</span>
          <span class="logo-separator">›</span>
          <span class="logo-compass">compass</span>
        </span>
      </div>
      <!-- Sign In Content Group -->
      <div class="signin-content">
        <!-- Logo Card -->
        <div class="logo-card" [style.background-color]="logoBackgroundColor">
          <img
            [src]="logoUrl"
            [alt]="idpName + ' logo'"
            class="university-logo"
          />
        </div>

        <!-- Sign In Button -->
        <span class="sr-only" aria-live="polite" role="status">{{ loadingMessage }}</span>
        <button
          type="button"
          (click)="handleContinueWithSSO()"
          [disabled]="isLoading"
          [attr.aria-busy]="isLoading"
          class="sign-in-button"
          [class.loading]="isLoading"
        >
          <span *ngIf="!isLoading">Sign in with School ID</span>
          <span *ngIf="isLoading" class="loading-content">
            <svg class="spinner" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-hidden="true">
              <circle class="spinner-track" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="spinner-head" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Signing in...
          </span>
        </button>

        <!-- Email Sign In Link -->
        <p *ngIf="showEmailSignIn" class="email-signin-text">
          If you have previously logged into Compass
          with your email, please sign in <a href="/login" class="here-link">here</a>.
        </p>
      </div>

      <!-- Privacy Policy -->
      <p class="privacy-text">
        By continuing, you agree to our
        <a
          href="https://www.ets.org/legal/privacy.html"
          target="_blank"
          rel="noopener noreferrer"
          class="privacy-link"
        >Privacy Policy</a>.
      </p>
    </div>

    <!-- Right Yellow Decorative Strip -->
    <div class="decorative-strip right-strip">
      <img
        src="/assets/images/biq/right-panel.svg"
        alt=""
        class="decorative-strip-img"
      />
    </div>
  </div>

  <!-- Footer -->
  <footer class="footer">
    <p class="copyright">
      Copyright &copy; {{ currentYear }} by Educational Testing Service. All rights reserved. All trademarks are the property of their respective owners.
    </p>
    <nav class="footer-links">
      <a href="https://www.ets.org/legal" target="_blank" rel="noopener noreferrer" class="footer-link">Legal</a>
      <span class="separator">|</span>
      <a href="/accessibility"  target="_blank" class="footer-link">Accessibility</a>
      <span class="separator">|</span>
      <a href="https://www.ets.org/legal/privacy.html" target="_blank" rel="noopener noreferrer" class="footer-link">Privacy &amp; Security</a>
      <span class="separator">|</span>
      <a href="https://www.ets.org/legal/trademarks/owned" target="_blank" rel="noopener noreferrer" class="footer-link">ETS Trademarks</a>
    </nav>
  </footer>

  <!-- Bottom Decorative Strip (mobile only) -->
  <div class="decorative-strip bottom-strip">
    <img
      src="/assets/images/biq/right-panel.svg"
      alt=""
      class="decorative-strip-img"
    />
  </div>
</div>
